export default {
    props: {
        enablePagination: {
            type: Boolean,
            default: false
        },
        //开启分页时传的字段
        totalCount: {
            type: [String, Number],
            default: 0
        },
        autoPageView: {
            type: Boolean,
            default: false
        },
        defaultPageSize: {
            type: [String, Number],
            default: '20'
        },
        totalLoading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            currentPage: 1,
            perPage: Number.parseInt(this.defaultPageSize),

            perPageSelect: [10, 20, 50, 100],
        };
    },
    computed: {
        limitRows() {
            if (this.autoPageView) {
                let list = [];
                let fromIndex = (this.currentPage - 1) * this.perPage;
                // console.log('here---000', fromIndex, this.perPage, fromIndex + this.perPage, this.finalRowList.length);
                for (let i = fromIndex; i < fromIndex + this.perPage && i < this.finalRowList.length; i++) {
                    list.push(this.finalRowList[i])
                }
                return list;
            } else {
                return this.finalRowList;
            }

        },
        totalRows() {
            if (this.autoPageView) {
                return this.finalRowList.length;
            } else {
                return this.totalCount;
            }
        },
    },
    watch: {
        perPage() {
            this.whenPageChange(this.currentPage);
        },
    },
    methods: {
        whenPageChange(page) {
            this.$emit('pageChange', {
                pageNumber: page - 1,
                pageSize: this.perPage,
            })
        },
    }
}
